"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Icon_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Icon"));
var ResponsiveMenu_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/ResponsiveMenu"));
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = require("styled-components");
var styled_components_2 = tslib_1.__importDefault(require("../Themes/styled-components"));
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var IconButton = (0, styled_components_2["default"])('button')(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 0;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 0;\n"])));
var C = function (props) {
    var _a = props.configuration, _b = _a === void 0 ? {} : _a, _c = _b.textColor, textColor = _c === void 0 ? '#333' : _c, _d = _b.backgroundColor, backgroundColor = _d === void 0 ? '#fff' : _d, sections = props.sections, renderLink = props.renderLink, position = props.position;
    var _e = props.configuration, _f = _e === void 0 ? {} : _e, _g = _f.subsectionBackgroundColor, subsectionBackgroundColor = _g === void 0 ? (0, utilities_1.emphasizeColor)(0.05, backgroundColor, true) : _g, _h = _f.linkColor, linkColor = _h === void 0 ? textColor : _h, _j = _f.linkColorHighlighted, linkColorHighlighted = _j === void 0 ? (0, utilities_1.emphasizeColor)(0.1, textColor) : _j, _k = _f.linkHoverColor, linkHoverColor = _k === void 0 ? (0, utilities_1.emphasizeColor)(0.1, backgroundColor, true) : _k, _l = _f.burgerColor, burgerColor = _l === void 0 ? textColor : _l;
    var _m = React.useState(false), visible = _m[0], setVisible = _m[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { onClick: function () {
                setVisible(true);
            } },
            React.createElement(Icon_1["default"], { name: "burger", size: 28, color: burgerColor })),
        sections && (React.createElement(styled_components_1.ThemeProvider, { theme: {
                responsiveMenu: {
                    backgroundColor: backgroundColor,
                    subsectionBackgroundColor: subsectionBackgroundColor,
                    linkColor: linkColor,
                    linkColorHighlighted: linkColorHighlighted,
                    linkHoverColor: linkHoverColor,
                    backdropColor: 'rgba(0,0,0,0.25)',
                    borderRadius: (0, polished_1.rem)(4),
                    siteUrlColor: textColor,
                    siteUrlBorder: textColor,
                    closeButtonColor: textColor
                }
            } },
            React.createElement(ResponsiveMenu_1["default"], { sections: sections, renderLink: renderLink, visible: visible, onClose: function () { return setVisible(false); }, depthLevel: 3, position: position })))));
};
exports["default"] = C;
var templateObject_1;
